import SectionArticlePadding from './SectionArticlePadding';
export default SectionArticlePadding;
